import React from 'react';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';

import Header from './components/Header';
import Navbar from './components/Navbar';
import Footer from './components/footer';
import ScrollToTopButton from './components/ScrollToTopButton';
import ScrollTop from './components/scrolltop';
import AppRoutes from './routes/AppRoutes';

const AppShell = () => {
  const { pathname } = useLocation();
  const hideChrome =
    pathname === '/apply-loan' ||
    pathname === '/apply-now' ||
    pathname === '/landing';

  return (
    <>
      <ScrollToTopButton />
      <ScrollTop />
      {!hideChrome && <Header />}
      {!hideChrome && <Navbar />}
      <AppRoutes />
      {!hideChrome && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppShell />
    </Router>
  );
};

export default App;
